/* Site-Specific JavaScript */

(function () {
    var header = document.getElementById('site-header');
    var banner = document.querySelector('.page-banner, .page-hero.ir-hero, .newsroom-page-title');
    if (!header || !banner || document.querySelector('.minor-announcement')) {
        return;
    }
    header.classList.toggle('transparent--solid', banner.classList.contains('newsroom-page-title'));
    var update = function () {
        header.classList.toggle('transparent', window.scrollY < 10);
    };
    window.addEventListener('scroll', update, { passive: true });

    // This runs after first paint, so the initial toggle would animate the nav
    // links away from the solid-header colors. Two frames are needed: removing
    // the class in the same frame as the toggle still lets the transition run.
    header.classList.add('no-transition');
    update();
    requestAnimationFrame(function () {
        requestAnimationFrame(function () {
            header.classList.remove('no-transition');
        });
    });
})();
